import { GzRuleCriteriaWebComponent } from './component/GzRuleCriteriaWebComponent';
import { GzRuleDefinitionWebComponent } from './component/GzRuleDefinitionWebComponent';

export { GzRuleCriteriaWebComponent, GzRuleDefinitionWebComponent };
